import { useEffect } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";

const navButtonSx = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  color: "common.white",
  bgcolor: "rgba(0, 0, 0, 0.4)",
  "&:hover": { bgcolor: "rgba(0, 0, 0, 0.6)" },
};

/** Visualizador de fotos em tela cheia com navegação (botões e setas do teclado). */
const MuralFotoLightbox = ({ fotos, index, onClose, onChangeIndex }) => {
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const open = index !== null && index >= 0 && index < fotos.length;
  const temAnterior = open && index > 0;
  const temProxima = open && index < fotos.length - 1;

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft" && temAnterior) onChangeIndex(index - 1);
      if (event.key === "ArrowRight" && temProxima) onChangeIndex(index + 1);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, index, temAnterior, temProxima, onChangeIndex]);

  if (!open) return null;

  return (
    <Dialog
      open
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="lg"
      fullWidth
      slotProps={{ paper: { sx: { bgcolor: "grey.900", color: "common.white" } } }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" px={2} py={1}>
        <Typography variant="body2">
          {index + 1} / {fotos.length}
        </Typography>
        <IconButton onClick={onClose} aria-label="Fechar" sx={{ color: "common.white" }}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ height: { xs: "calc(100vh - 56px)", sm: "80vh" } }}
      >
        <Box
          component="img"
          src={fotos[index].foto}
          alt={`Foto ${index + 1} de ${fotos.length}`}
          sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
        {temAnterior && (
          <IconButton aria-label="Foto anterior" onClick={() => onChangeIndex(index - 1)} sx={{ ...navButtonSx, left: 8 }}>
            <ChevronLeftIcon fontSize="large" />
          </IconButton>
        )}
        {temProxima && (
          <IconButton aria-label="Próxima foto" onClick={() => onChangeIndex(index + 1)} sx={{ ...navButtonSx, right: 8 }}>
            <ChevronRightIcon fontSize="large" />
          </IconButton>
        )}
      </Box>
    </Dialog>
  );
};

export default MuralFotoLightbox;
